function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#77cffd;}.cls-3{fill:#3195e3;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#2285e1;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 54.93,
  y1: 1037.62,
  x2: 54.36,
  y2: 1037.26,
  gradientTransform: "matrix(354, 0, 0, -321, -18903.11, 333434.11)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3c9fe6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#77cffd"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 54.76,
  y1: 1036.99,
  x2: 53.76,
  y2: 1037.62,
  gradientTransform: "matrix(354, 0, 0, -321, -19062.11, 333323.11)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#2285e1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#2581cb"
})));

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Artboard 1");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  className: "cls-1",
  points: "159 516 159 636 513 435 513 315 159 516"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  className: "cls-2",
  points: "159 231 513 432 513 312 159 111 159 231"
}), /*#__PURE__*/React.createElement("g", {
  id: "Fill-3"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  className: "cls-3",
  points: "0 324 354 525 354 405 0 204 0 324"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3-2",
  "data-name": "path-3",
  className: "cls-4",
  points: "0 324 354 525 354 405 0 204 0 324"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  className: "cls-3",
  points: "354 0 0 201 0 321 354 120 354 0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-5",
  className: "cls-5",
  d: "M354,405.28V525L248.58,465.14ZM159,230.72V111l105.43,59.86Z"
}));

const SvgSplitio = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 513 636",
  ref: svgRef
}, props), _ref, title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSplitio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/splitio.5fa73190.svg";
export { ForwardRef as ReactComponent };